import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const isConnected = useSelector((store) => store.user.isConnected);
  return isConnected ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
